/*
 * Selectors using reselect.
 */
import { createSelector } from 'reselect';

const formSelector = state => state.form;

export const guestInfoSelector = createSelector(
  formSelector,
  subState => subState.guestInfo && subState.guestInfo.values
);

export const reviewAndSubmitFormSelector = createSelector(
  formSelector,
  subState => subState.reviewAndSubmit && subState.reviewAndSubmit.values
);
